import React from 'react'

import Backend from '../utils/Backend'
import AuthManager from '../utils/AuthManager'

import TemplatesTable from './components/tables/TemplatesTable'

export default class Templates extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
    }
  }

  render() {
    return (
      <div className="row">
        <TemplatesTable
          title="Templates"
        />
      </div>
    )
  }
}
